import React from 'react';
import { teaser } from '../../../../constants/companies';

export default function Teaser () {
  return <div className='alert alert-info alert-static'>{teaser}</div>;
}



// WEBPACK FOOTER //
// ./src/components/app/companyDetails/Tabs/Teaser.js